import React, { FC, useEffect, useState } from "react";
import { ReactComponent as BoldPlus } from "images/BoldPlus.svg";
import { ReactComponent as File } from "images/FileV2.svg";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import cn from "classnames";
import styles from "./DocumentAttachment.module.sass";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { uploadDocument } from "toolkit/steps/stepSeven/stepSeven.thunks";
import {
	changeAttachmentMode,
	changeSearchValue,
	clearAttachmentList,
	clearGlobalChecked,
} from "toolkit/steps/stepSeven/stepSeven.slice";

interface DocumentAttachmentProps {
	close: () => void;
	setDocumentAttached: (value: boolean) => void;
}

export const DocumentAttachment: FC<DocumentAttachmentProps> = ({ close, setDocumentAttached }) => {
	const { organizationId } = useParams();
	const { attachmentList, allCheckedGlobal } = useAppSelector((state) => state.stepSeven);
	const dispatch = useAppDispatch();
	const [loading, setLoading] = useState<boolean>(false);
	const [dragActive, setDragActive] = useState<boolean>(false);
	const [document, setDocument] = useState<any>(null);

	const documentHandler = (files: FileList | null) => {
		setDocument(files![0]);
		setDocumentAttached(true);
	};

	useEffect(() => {
		return () => {
			setDocumentAttached(false);
		};
		//eslint-disable-next-line
	}, []);

	const uploadingDocumentHandler = () => {
		if (!organizationId) return;
		// dispatch(FilterData(null))
		setLoading(true);
		dispatch(
			uploadDocument({
				organizationId: +organizationId,
				file: document,
				allCheckedGlobal: Boolean(allCheckedGlobal),
				attachmentList,
				excludedObjects: [],
				filter: false,
				handler: false,
				callBack,
			}),
		);
	};

	const dragEnterHandler = (e: React.DragEvent<HTMLDivElement>) => {
		setDragActive(true);
		e.preventDefault();
		e.stopPropagation();
	};

	const dragLeaveHandler = (e: React.DragEvent<HTMLDivElement>) => {
		setDragActive(false);
		e.preventDefault();
		e.stopPropagation();
	};

	const handleDrop = (e: any) => {
		e.preventDefault();
		let dt = e.dataTransfer;
		let files = dt.files;
		documentHandler(files);
	};

	const callBack = () => {
		dispatch(changeAttachmentMode(false));
		dispatch(clearAttachmentList());
		dispatch(clearGlobalChecked());
		dispatch(changeSearchValue(""));
		close();
	};

	return (
		<>
			{document ? (
				<section className={styles.wrp}>
					<h4 className={styles.title}>
						Документ прикреплен! <br /> Завершите настройку
					</h4>
					<div className={styles.document}>
						<File />
						<span className={styles["document-name"]}>{document.name}</span>
					</div>
					<div className={styles.btns}>
						<Button
							disabled={loading}
							onClick={close}
							type="button"
							variant={BUTTON_VARIANTS.OUTLINED}
							className={styles.button}>
							Отменить
						</Button>
						<Button loading={loading} onClick={uploadingDocumentHandler} className={styles.button}>
							Готово
						</Button>
					</div>
				</section>
			) : (
				<section className={styles.wrp}>
					<h4 className={styles.title}>Прикрепление документа</h4>
					<div
						onDragOver={dragEnterHandler}
						onDragLeave={dragLeaveHandler}
						onDrop={handleDrop}
						className={cn(styles.field, dragActive && styles.drag)}>
						<div className={styles["field-info"]}>
							<div className={styles.plus}>
								<BoldPlus />
							</div>
							<span className={styles["field-info-txt"]}>
								Перетащите документ <br /> в это окно или
							</span>

							<input
								onChange={(e) => documentHandler(e.target.files)}
								type="file"
								id={`uploadDoc`}
								className="none"
								accept=".docx, .pdf, .rtf"
							/>
							<label title={document && document.name} htmlFor={`uploadDoc`} className={styles.label}>
								Выберите документ на компьютере
							</label>
						</div>
					</div>
				</section>
			)}
		</>
	);
};
